import React, { ReactNode, SFC } from 'react';
import { CSSTransition } from 'react-transition-group';

interface Props {
    in: boolean;
    children: ReactNode;
}

const DrawerTransition: SFC<Props> = ({ in: inProp, children, ...rest }) => (
    <CSSTransition in={inProp} classNames="drawer-wrapper" timeout={300} {...rest}>
        <div className="drawer-wrapper">{children}</div>
    </CSSTransition>
);

export default DrawerTransition;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/transitions/drawer-transition.tsx